import base from './base'

let controller = 'company'
let action = null

const Company = {
  async listCompanies (query, pageIndex = 1, pageSize = 20) {
    let querys = {
      currentPage: pageIndex || query.pageIdex,
      pageSize: pageSize || query.pageSize,
      sort: query.sort,
      ascending: query.ascending
    }
    Object.assign(querys, query)
    querys.isLocal = query.isLocal !== null ? query.isLocal ? true : false : null
    action = 'ListCompanies'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },

  async addCompany (request) {
    let model = {
      type: request.type || null,
      name: request.name || null,
      legalPersonName: request.legalPersonName || null,
      businessLicense: request.businessLicense || null,
      regCity: request.regCity || null,
      contact: request.contact || null,
      contactTel: request.contactTel || null,
      address: request.address || null,
      email: request.email || null,
      isLocal: request.isLocal || true
    }
    action = 'Create'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: model
    }
    return base.request(reqModel)
  },

  async updateCompany (request) {
    let model = {
      id: request.id || request.tid || null,
      type: request.type || null,
      name: request.name || null,
      legalPersonName: request.legalPersonName || null,
      businessLicense: request.businessLicense || null,
      regCity: request.regCity || null,
      contact: request.contact || null,
      contactTel: request.contactTel || null,
      address: request.address || null,
      email: request.email || null,
      isLocal: request.isLocal || true
    }
    if (!model.id) {
      throw new Error('提交数据不合法!ID为空')
    }
    action = `Update/${model.id}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: model
    }
    return base.request(reqModel)
  },

  async deleteCompany (companyId) {
    if (!companyId) {
      throw new Error('CompanyId为空')
    }
    action = `Delete/${companyId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  }
}

export default Company